/* AJAX response interceptor for csrf protection */
(function (XHR) {
    'use strict';

    var open = XHR.prototype.open,
        send = XHR.prototype.send;

    XHR.prototype.open = function (method, url, async, user, pass) {
        this._url = url;
        this._method = method;
        open.call(this, method, url, async, user, pass);
    };

    XHR.prototype.send = function (data) {
        var self = this,
            response,
            token;

        token = StorageService.cookie.getCookie(getCsrfTokenName());

        function isHumanityRequest (url) {
            // If url doesn't contain protocol, this is Humanity request
            // e.g. /app/
            if (url.indexOf('http') === -1) {
                return true;
            }

            // If url contains HTTP protocol and correct domain name, this is Humanity request
            if (url.indexOf('http') === 0 && url.indexOf(_cookieDomain_) !== -1) {
                return true;
            }

            return false;
        }

        function onReadyStateChange () {
            // check only for Humanity requests
            if (self.readyState == 4 && isHumanityRequest(self._url) && self.getAllResponseHeaders().indexOf('x-csrf-error') >= 0) {
                _status('Your session has expired. Please re-authenticate.');
                setTimeout(function () {
                    window.location.replace(_base_);
                }, 2000);
                self.abort();
            } else if (self.readyState == 4) {
                try {
                    // response = JSON.parse(self.response);
                } catch (e) {
                    if (typeof SentryWrapper !== 'undefined' && SentryWrapper && typeof SentryWrapper.exceptionHandling === 'function') {
                        SentryWrapper.exceptionHandling(e);
                    }
                    self.abort();
                }
                if (typeof response === 'object' && parseInt(response.status) !== 1 && response.error) {
                    SentryWrapper.exceptionHandling(response.error, {'response': JSON.stringify(response)});
                    self.abort();
                }
            }
        }

        self.addEventListener('readystatechange', onReadyStateChange, false);

        if (isHumanityRequest(self._url) && token) {
            if (typeof data !== 'undefined' && typeof data !== 'object') {
                if (data.indexOf(getCsrfTokenName()) === -1) {
                    data += '&' + getCsrfTokenName() + '=' + token;
                }
            } else {
                self.setRequestHeader('x-csrf-token', token);
            }
        }

        send.call(this, data);
    };
})(XMLHttpRequest);
